import request from '@/utils/request'
import URL from './urlTranslator'

export function getActionLogList(data) {
  return request({
    url: `${URL.actionLog.list}`,
    method: 'post',
    data: data
  })
}

export function queryByJouUuid(jobUuid) {
  return request({
    url: `${URL.actionLog.queryByJouUuid}`,
    method: 'get',
    params: { jobUuid }
  })
}

export function queryByJouUuidPage(jobUuid, pageNum, pageSize) {
  return request({
    url: `${URL.actionLog.queryByJouUuidPage}`,
    method: 'get',
    params: { jobUuid, pageNum, pageSize }
  })
}
